import { Environment, ENVIRONMENT_TOKEN, StoreWrapperInterface, STORE_WRAPPER_TOKEN } from '@actassa/api';
import { ComplexResponse } from '@actassa/shared';
import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { Dispatch } from '@ngxs-labs/dispatch-decorator';
import { Actions, ofActionDispatched } from '@ngxs/store';
import { merge, NEVER, Observable } from 'rxjs';
import { catchError, switchMap, tap, throttleTime } from 'rxjs/operators';

import { LoadTemplates } from '../+state/actions/load-templates';
import { LoadTemplatesForced } from '../+state/actions/load-templates-forced';
import { LoadTemplatesSuccess } from '../+state/actions/load-templates-success';
import { THROTTLE_TIMEOUT } from '../constants/constants';
import { TemplateInterface } from '../interfaces/template.interface';

@Injectable()
export class TemplatesService {
    constructor(
        @Inject(STORE_WRAPPER_TOKEN) private storeWrapper: StoreWrapperInterface,
        @Inject(ENVIRONMENT_TOKEN) private readonly environment: Environment,
        private readonly actions$: Actions,
        private readonly http: HttpClient,
    ) { }

    public init$(): Observable<unknown> {
        return merge(
            this.actions$
                .pipe(
                    ofActionDispatched(LoadTemplates),
                    throttleTime(THROTTLE_TIMEOUT),
                    switchMap(() => this.load$()),
                    tap((response) => this.responseHandler(response)),
                    catchError((error) => {
                        this.storeWrapper.showToast(error.message);

                        return NEVER;
                    }),
                ),
            this.actions$
                .pipe(
                    ofActionDispatched(LoadTemplatesForced),
                    switchMap(() => this.load$()),
                    tap((response) => this.responseHandler(response)),
                    catchError((error) => {
                        this.storeWrapper.showToast(error.message);

                        return NEVER;
                    }),
                ),
        );
    }

    public load$(): Observable<ComplexResponse<Array<TemplateInterface>>> {
        const url = this.buildLoadUrl();

        return this.http.get<ComplexResponse<Array<TemplateInterface>>>(url);
    }

    private responseHandler(response: ComplexResponse<Array<TemplateInterface>>): void {
        if (!response) {
            this.storeWrapper.showToast('Data request error. Please, check internet connection.');

            return;
        }

        const { message, status, data } = response;

        this.storeWrapper.showToast(message);

        if (status === 'ok' && data) {
            this.loadTemplatesSuccess(data);
        }
    }

    private buildLoadUrl(): string {
        return `${this.environment.apiURL}/inspections/templates`;
    }

    @Dispatch()
    private loadTemplatesSuccess(templates: Array<TemplateInterface>): LoadTemplatesSuccess {
        return new LoadTemplatesSuccess(templates);
    }
}
